import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import NotAccess from "./ErrorPage/NotAccess";
import LoadingPage from "./Loader/LoadingPage";
import { getUserRoleFromLocal, getUserRoleFromOrg } from "../utils/helper";
import { useParams } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [userRole, setUserRole] = useState("");
  const [hasAccess, setHasAccess] = useState(false);
  const { _orgId } = useParams();

  useEffect(() => {
    const checkPermissions = async () => {
      try {
        // Get user role from local storage first
        const userRoleFromLocal = getUserRoleFromLocal();
        
        // If no role in local storage, try to get it from the organization
        if (!userRoleFromLocal || userRoleFromLocal === "null") {
          const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
          const userId = UserLogged?.user?.id;
          
          if (userId && _orgId) {
            const orgRole = await getUserRoleFromOrg(_orgId, userId);
            setUserRole(orgRole);
            setHasAccess(orgRole === "Admin" || orgRole === "Reviewer" || orgRole === "Approver");
          } else {
            setHasAccess(false);
          }
        } else {
          setUserRole(userRoleFromLocal);
          // Allow access for Admin, Reviewer, and Approver roles
          setHasAccess(userRoleFromLocal === "Admin" || userRoleFromLocal === "Reviewer" || userRoleFromLocal === "Approver");
        }
        
      } catch (error) {
        console.error("🔐 ProtectedRoute: Error checking permissions:", error);
        setHasAccess(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkPermissions();
  }, [_orgId]);

  if (isLoading) {
    return <LoadingPage isLoading={true} alterElement={""} />;
  }



  return hasAccess ? <Outlet /> : <NotAccess />;
};

export default ProtectedRoute;
